import { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { getKeywordFilterOptions } from "../../../services/container";
import { groupKeywordFilterOptions } from "../../activity/utils/activityPageFilters";

/**
 * Hook pour gérer les filtres keyword des statistiques (Performance).
 * Options loaded once with an empty filter so lists stay complete when switching.
 */
export const useStatisticsFilters = () => {
  const location = useLocation();
  const [keywordFilterOptions, setKeywordFilterOptions] = useState([]);
  const [keywordFilter, setKeywordFilter] = useState(
    location?.state?.keywordFilter || { value: [] },
  );

  useEffect(() => {
    getKeywordFilterOptions({
      keywordFilter: JSON.stringify([]),
    }).then((res) => {
      if (res.status === 200) {
        setKeywordFilterOptions(res.data.keywordFilterOptions || []);
      }
    });
  }, []);

  const groupedOptions = useMemo(
    () => groupKeywordFilterOptions(keywordFilterOptions),
    [keywordFilterOptions],
  );

  return {
    keywordFilter,
    setKeywordFilter,
    groupedOptions,
  };
};
